import { useMutation } from "react-query";
import { duplicateFleet } from "store/api/api";
import { handleAxiosError } from "store/util";
import { MUTATION_KEYS } from "../queryKeys";

export function useDuplicateFleet() {
  return useMutation(duplicateFleet, {
    mutationKey: MUTATION_KEYS.duplicateFleet,
    onError: (err) => {
      handleAxiosError(err);
    },
  });
}
